import Vue from "vue";
import Router from "vue-router";
import Login from "@/components/Login";
import License from "@/components/License";
import Master from "@/components/Master";
import Home from "@/components/Home";
import SessionExpire from "@/components/SessionExpire";
import MasterEntry from "@/components/MasterEntry";
import MyBooking from "@/components/MyBooking";
import ScanTicket from "@/components/ScanTicket";
import UserProfile from "@/components/UserProfile";
import TicketBooking from "@/components/TicketBooking";
import BookingSlots from "@/components/BookingSlots";
import PrintTicket from "@/components/PrintTicket";
import UserManagement from "@/components/UserManagement";
import ChangePassword from "@/components/ChangePassword";
import TransResponse from "@/components/TransResponse";
import TransError from "@/components/TransError";
import TransRequest from "@/components/TransRequest";
import PaymentPortal from "@/components/PaymentPortal";
import RefundRequest from "@/components/RefundRequest";
import RefundResponse from "@/components/RefundResponse";
import CMS from "@/components/CMS";

Vue.use(Router);

export default new Router({
  routes: [
    { path: "/", name: "Login", component: Login },
    { path: "/License", name: "License", component: License },
    { path: "/SessionExpire", name: "SessionExpire", component: SessionExpire },
    {
      path: "/Master",
      name: "Master",
      component: Master,
      children: [
        { path: "/Home", name: "Home", component: Home },
        { path: "/MasterEntry", name: "MasterEntry", component: MasterEntry },
        { path: "/MyBooking", name: "MyBooking", component: MyBooking },
        { path: "/ScanTicket", name: "ScanTicket", component: ScanTicket },
        { path: "/UserProfile", name: "UserProfile", component: UserProfile },
        {
          path: "/TicketBooking",
          name: "TicketBooking",
          component: TicketBooking
        },
        {
          path: "/BookingSlots",
          name: "BookingSlots",
          component: BookingSlots
        },
        { path: "/PrintTicket", name: "PrintTicket", component: PrintTicket },
        {
          path: "/UserManagement",
          name: "UserManagement",
          component: UserManagement
        },
        {
          path: "/ChangePassword",
          name: "ChangePassword",
          component: ChangePassword
        },
        {
          path: "/TransResponse",
          name: "TransResponse",
          component: TransResponse
        },
        { path: "/TransError", name: "TransError", component: TransError },
        {
          path: "/TransRequest",
          name: "TransRequest",
          component: TransRequest
        },
        {
          path: "/PaymentPortal",
          name: "PaymentPortal",
          component: PaymentPortal
        },
        {
          path: "/RefundRequest",
          name: "RefundRequest",
          component: RefundRequest
        },
        {
          path: "/RefundResponse",
          name: "RefundResponse",
          component: RefundResponse
        },
        { path: "/CMS", name: "CMS", component: CMS }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js